import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import { URL, MESSAGE } from '../../../../constant';
import { useAlert, useInput, useUserInfo, useGmAppLogin } from '../../../../hooks';
import { AuthNumForm, EmailForm, MobileEmailAuthBtn, PwdForm } from '../common';
import { emailRegExp, passwordRegExp, translationKoMsg } from '../../../../utils/utilityEtc';
import { emailSendAPI, emailVerifyAPI, memberJoinAPI } from '../../../../api/accountAPI';
import { BackButtons } from '../../../navigate';


// eslint-disable-next-line no-unused-vars
let authEmail = '';
function MemberAuthSuccess() {
  const history = useHistory();
  const location = useLocation();
  const { info } = useUserInfo();
  const [gmAppLogin, loginCheck] = useGmAppLogin();
  const [Alert] = useAlert();

  const [pwd, onPwdChange, onPwdReset] = useInput('');
  const [rePwd, onRePwdChange, onRePwdReset] = useInput('');
  const [email, onChangeEmail, onEmailReset] = useInput('');
  const [authNum, onChangeAuthNum, onAuthNumReset] = useInput('');

  const [pwdCheck, setPwdCheck] = useState('');
  const [authNumMsg, setAuthNumMsg] = useState('');
  const [emailCheck, setEmailCheck] = useState('');
  const [btnType, setBtnType] = useState("auth");
  const [resp, setResp] = useState(null);

  useEffect(() => {
    const { state } = location;
    if (state?.result) {
      setResp(state.result);
    } else {
      Alert(
        MESSAGE.INVALID_ACCESS,
        () => history.push(URL.ACCOUNT.GM_MEMBER_AUTH),
        "msg005"
      )
    }
  }, []);

  useEffect(() => {
    if (loginCheck === 'fail') {
      Alert(MESSAGE.INTERNAL_SERVER_ERROR.msg, null, 'msg002');
    }
  }, [loginCheck])

  const handleMouseDown = (e) => e.preventDefault();
  // 변경하기, 인증하기, 재전송
  const handleChangeBtn = useCallback((type) => {
    setBtnType(type);
  }, []);

  const onBlur = useCallback((e) => {
    const name = e.target.name;
    // 이메일 체크
    if (_.isEqual(name, 'email')) {
      if (!email) return;
      // 이메일 양식이 맞으면  true 아니면 false;
      const result = emailRegExp(email);
      setEmailCheck(result ? 'success' : 'fail');
    }
    // 비밀번호 체크
    if (_.isEqual(name, 'pwd') || _.isEqual(name, 'rePwd')) {
      if (!passwordRegExp(pwd)) {
        setPwdCheck('pattern');
        return;
      } else if (!_.isEqual(pwd, rePwd)) {
        setPwdCheck('diff');
        return;
      }
      setPwdCheck('success');
    }
  }, [email, pwd, rePwd]);

  // 이메일 인증번호 받기
  const handleSend = useCallback(async () => {
    if (!email) return;
    onAuthNumReset();
    const result = await emailSendAPI({
      emailAdrs: email,
      chnCd: info?.channelCode
    });
    if (result?.code === 'S000000') {
      setBtnType('resend');
      authEmail = email;
    } else {
      setBtnType('auth');
      // if (!result) Alert(MESSAGE.UNKNOWN_ERROR);
      
    }
  }, [email]);

  // 이메일 인증번호 확인
  const handleAuthNum = useCallback(async () => {
    if (authNum.length < 4 || btnType !== 'resend') return;

    // 이메일 인증 번호 확인
    const authResp = await emailVerifyAPI({
      emailAuthNo: authNum
    });

    if (authResp.code !== 'S000000') {
      setAuthNumMsg(translationKoMsg(authResp.code));
      return;
    } else {
      setAuthNumMsg("");
    }
    
  }, [authNum])

  const onSubmit = async () => {
    const { parentCstmrNo } = resp;
    if (!_.isEmpty(authNumMsg)) return;
    if (authEmail !== email) {
      Alert("이메일 인증받기 버튼을 선택해 주세요.");
      return;
    };
    
    
    const joinResp = await memberJoinAPI({
      chnCd: info.channelCode,
      parentCstmrNo,
      emailAdrs: email,
      pw: pwd
    });

    if (joinResp.code === 'S000000') {
      Alert(
        "회원인증이 완료되었습니다.",
        () => {
          gmAppLogin(pwd, email);
        }
      )
    } else {
      if (joinResp?.resp.msg) {
        Alert(translationKoMsg(joinResp?.code));
      }
    }
  }

  return (
    <React.Fragment>
      <div className="header_top">
        <div className="inner">
          <div className="btns_wrap header-trans cls">
            <div className="app_btn">
              <BackButtons />
            </div>
            <div className="tit_gm center_tit24">입회 회원 인증</div>
          </div>
        </div>
      </div>
      <div className="layout-def layout-sl bg_gray2 inner_w100p">
        <div className="container">
          <div className="inner">
            <div className="mem_chk_done">
              <div className="img_wrap">
                <img src="./static/images/common/img_my_05_02_certification.svg" alt="" />
              </div>
              <div className="tit_wrap">웅진씽크빅 입회 회원 인증 완료</div>
              <div className="box">
              <div className="tit">AI바로셈에 입회한 자녀입니다.</div>
                <ul>
                {
                  (resp && resp.learner.length > 0) && (
                    resp.learner.map((item, index) => (
                      <li key={index}>{item.name}&nbsp;&nbsp;{moment(item.birth).format('YYYY. MM')}</li>
                    ))
                  )
                  }
                </ul>
              </div>
            </div>
            <div className="tit_txt">AI바로셈에서 사용하실 <br className="hide_pc hide_t" />이메일과 비밀번호를 설정해 주세요.</div>
            <div className="wirte_form gm_ver w520">
              <section>
                <div className="item">
                  <div className="input_title">이메일</div>
                  <div className="input_cont h56">
                    <MobileEmailAuthBtn
                      btnType={btnType}
                      handleChangeBtn={handleChangeBtn}
                      handleSend={handleSend}
                    />
                    <ul>
                      <li>
                        <EmailForm
                          email={email}
                          onChangeEmail={onChangeEmail}
                          onBlur={onBlur}
                          emailCheck={emailCheck}
                          onEmailReset={onEmailReset}
                          handleMouseDown={handleMouseDown}
                          btnType={btnType}
                          handleSend={handleSend}
                        />
                      </li>
                      <li>
                        <AuthNumForm
                          authNum={authNum}
                          onChangeAuthNum={onChangeAuthNum}
                          authNumMsg={authNumMsg}
                          setAuthNumMsg={setAuthNumMsg}
                          onAuthNumReset={onAuthNumReset}
                          handleMouseDown={handleMouseDown}
                          handleAuthNum={handleAuthNum}
                          btnType={btnType}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
                <PwdForm
                  pwd={pwd}
                  onBlur={onBlur}
                  onPwdChange={onPwdChange}
                  pwdCheck={pwdCheck}
                  onPwdReset={onPwdReset}
                  handleMouseDown={handleMouseDown}
                  rePwd={rePwd}
                  onRePwdChange={onRePwdChange}
                  onRePwdReset={onRePwdReset}
                />
              </section>
            </div>
            <div className="page_lower_wrap">
              <div className="w520">
                <button
                  className="btn btn-blue"
                  disabled={
                    !_.isEqual(btnType, 'resend')
                    || _.isEmpty(authNum)
                    || _.isEmpty(pwd)
                    || _.isEmpty(rePwd)
                    || !_.isEmpty(authNumMsg)
                    || !_.isEqual(emailCheck, 'success')
                    || !_.isEqual(pwdCheck, 'success')
                  }
                  onClick={onSubmit}
                >완료</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MemberAuthSuccess;